import React, { memo } from "react";
import ImageCarousel from "./ImageCarousel";
import "../styles/ImageCarousel.css";

interface ReportImageGalleryProps {
  images: string[];
  showPreviews?: boolean;
}

const ReportImageGallery: React.FC<ReportImageGalleryProps> = memo(
  ({ images, showPreviews = true }) => {
    return <ImageCarousel images={images} showPreviews={showPreviews} />;
  }
);

ReportImageGallery.displayName = "ReportImageGallery";

export default ReportImageGallery;
